import { useState } from 'react';
import type { ProductDetail } from '../../../mocks/productDetails';

interface ProductDetailsProps {
  product: ProductDetail;
}

export default function ProductDetails({ product }: ProductDetailsProps) {
  const [activeTab, setActiveTab] = useState<'materials' | 'shipping'>('materials');

  return (
    <div className="space-y-8">
      {/* Tab Navigation */}
      <div className="flex gap-2 border-b border-white/10">
        <button
          onClick={() => setActiveTab('materials')}
          className={`px-6 py-3 font-medium transition-all duration-200 whitespace-nowrap ${
            activeTab === 'materials'
              ? 'text-white border-b-2 border-white'
              : 'text-white/60 hover:text-white'
          }`}
        >
          Materials & Care
        </button>
        <button
          onClick={() => setActiveTab('shipping')}
          className={`px-6 py-3 font-medium transition-all duration-200 whitespace-nowrap ${
            activeTab === 'shipping'
              ? 'text-white border-b-2 border-white'
              : 'text-white/60 hover:text-white'
          }`}
        >
          Shipping & Delivery
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'materials' && (
        <div className="space-y-6">
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-3">
              Materials
            </h3>
            <p className="text-white/80 leading-relaxed">{product.materials}</p>
          </div>
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-3">
              Fit & Sizing
            </h3>
            <p className="text-white/80 leading-relaxed">{product.fit}</p>
          </div>
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-3">
              Care Instructions
            </h3>
            <p className="text-white/80 leading-relaxed">{product.care}</p>
          </div>
        </div>
      )}

      {activeTab === 'shipping' && (
        <div className="space-y-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white/5 p-6 rounded-lg border border-white/10">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-lg mb-4">
                <i className="ri-truck-line text-2xl text-white"></i>
              </div>
              <h3 className="text-white font-bold mb-2">Standard Shipping</h3>
              <p className="text-white/80 text-sm mb-3">
                Free on orders over $100. Delivery in 5-7 business days across the U.S.
              </p>
              <p className="text-white/60 text-xs">$8.99 for orders under $100</p>
            </div>

            <div className="bg-white/5 p-6 rounded-lg border border-white/10">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 rounded-lg mb-4">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <h3 className="text-white font-bold mb-2">Local Delivery</h3>
              <p className="text-white/80 text-sm mb-3">
                Free same-day or next-day delivery available in Kalamazoo and Grand Rapids area.
              </p>
              <p className="text-white/60 text-xs">Available at checkout</p>
            </div>
          </div>

          <div className="bg-white/5 p-6 rounded-lg border border-white/10">
            <h3 className="text-white font-bold mb-4">Returns & Exchanges</h3>
            <ul className="space-y-2 text-white/80 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-white text-lg mt-0.5 flex-shrink-0"></i>
                <span>30-day return window for unworn items with original tags</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-white text-lg mt-0.5 flex-shrink-0"></i>
                <span>Free returns on all U.S. orders</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-white text-lg mt-0.5 flex-shrink-0"></i>
                <span>Exchanges processed within 3-5 business days</span>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}